module.exports = __webpack_public_path__ + "img/posicion_sin_ilegal.546420ec.gif";